<template>
  <section>
    <div v-if="nav == 'main'">
      <div v-if="classes.length > 0">
        <v-btn
          class="blue btn mb-8 float-right"
          dark
          @click="addDialog = true"
          >Nova Turma</v-btn
        >
        <v-btn
          class="blue btn mr-4 mb-8 float-right"
          dark
          @click="openSearch"
          >Buscar Turmas</v-btn
        >

        <div class="clear-all">
          <AssistentCard
            v-if="!admin"
            class="ml-0 mb-10"
            text="Adicione turmas para alocação!"
          />

          <v-btn
            v-if="addedClasses.length > 0 && !changed"
            dark
            class="grey mb-8"
            >{{ admin ? 'Salvar alterações' : 'Enviar' }}</v-btn
          > 

          <v-btn
            v-else-if="addedClasses.length > 0"
            dark
            class="blue mb-8"
            :loading="loading_"
            @click="handleSaveDialog"
            >{{ admin ? 'Salvar alterações e fechar' : 'Enviar' }}</v-btn
          >

          <v-dialog v-model="sendDialog" max-width="500">
            <v-card class="pa-4">
              <v-card-title class="pl-0 pb-6 text-h6">
                Enviar solicitação?
              </v-card-title>
              <v-card-text class="ml-n4">
                As turmas adicionadas e alterações feitas serão
                enviadas. Você não terá mais acesso a esta
                solicitação.
              </v-card-text>
              <v-card-actions class="pa-0 pt-7">
                <v-btn small class="blue" dark @click="send"
                  >Enviar</v-btn
                >
                <v-btn small plain @click="() => (sendDialog = false)"
                  >Cancelar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-data-table
            :items-per-page="-1"
            hide-default-footer
            :headers="headers.main"
            :items="addedClasses"
          >
            <!-- Add help icons next to headers -->
            <template
              v-for="header in headers.requests"
              v-slot:[`header.${header.value}`]
            >
              {{ header.text == "delete" ? "" : header.text }}
            </template>
            <template v-slot:item.pcd="{ item }">
              <p class="mb-0">
                <v-icon v-if="item.pcd" color="blue"
                  >mdi-wheelchair</v-icon
                >
                {{ item.pcd ? "" : "-" }}
              </p>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="() => handleEdit(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon small @click="handleDelete(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </div>
      </div>

      <NotFound
        v-if="classes.length == 0"
        type="team"
        :title="'Adicione turmas!'"
        btn="Adicionar Turmas"
        :btnFunction="openSearch"
        :text="
          'Aqui você pode buscar, adicionar e editar novas turmas. Comece clicando em adicionar turmas. Ao finalizar clique em enviar. '
        "
      />
      <!-- Add new class dialog -->
      <v-dialog v-model="addDialog" persistent max-width="700">
        <PaasForms
          option="classes"
          :add="addNewClass"
          :noPreferences="!rooms.length > 0"
          noPreAloc
          :addDep="() => {}"
          :roomTypes="roomTypes"
          :trigger="addDialog"
          :close="() => (addDialog = false)"
        />
      </v-dialog>

      <v-dialog v-model="edit.dialog" persistent max-width="700">
        <PaasForms
          option="classes"
          edit
          :noPreferences="!rooms.length > 0"
          noPreAloc
          :editObject="edit.placeholder"
          :add="editItem"
          :roomTypes="roomTypes"
          :rooms="[]"
          :close="() => (edit.dialog = false)"
        />
      </v-dialog>
    </div>

    <div v-if="nav == 'search'">
      <v-btn class="btn" plain @click="() => (nav = 'main')"
        >voltar</v-btn
      >

      <search-classes-input
        class="my-4"
        @start-request="handleStartGetClasses"
        @finish-request="handleFinishGetClasses"
      />

      <Loading
        v-if="searchClasses.loading"
        text="Buscando por classes..."
      />

      <div
        v-if="searchClasses.classList.length > 0"
        class="clear-all"
      >
        <v-btn
          v-if="searchClasses.classList.length > 0"
          dark
          class="blue"
          @click="sendClasses"
          >Adicionar Selecionadas</v-btn
        >

        <!-- Search box -->
        <div class="search pt-1 my-8">
          <v-text-field
            v-model="search"
            outlined
            dense
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          ></v-text-field>
        </div>

        <p v-if="searchClasses.validateSelect" class="color-red">
          Selecione ao menos uma turma!
        </p>
        <!-- List of classes -->
        <v-data-table
          v-model="searchClasses.selected"
          show-select
          :search="search"
          :headers="headers.search"
          :items-per-page="-1"
          :items="exibClass"
          item-key="idx"
          hide-default-footer
          class="elevation-1"
        >
          <!-- allow search without special characters -->
          <template v-slot:item.all="{ item }">
            <p class="mb-0">{{ item.codigo }}</p>
          </template>

          <template
            v-for="header in searchClasses.headers"
            v-slot:[`header.${header.value}`]
          >
            {{ header.text == "PCD" ? "" : header.text }}
            <div
              :key="header.value"
              v-if="header.text == 'PCD'"
              class="mb-n4"
            >
              <v-icon>mdi-wheelchair</v-icon>
              <HelpIcon
                v-if="header.helpText != undefined"
                small
                :text="header.helpText"
              />
            </div>
          </template>

          <template v-slot:item.pcd="{ item }">
            <p class="mb-0">
              <v-icon v-if="item.pcd" color="blue"
                >mdi-wheelchair</v-icon
              >
              {{ item.pcd ? "" : "-" }}
            </p>
          </template>
        </v-data-table>
      </div>
    </div>
  </section>
</template>

<script>
import Loading from "@/components/Loading.vue";
import PaasForms from "@/components/paas/PaasForms.vue";
import AssistentCard from "@/components/AssistentCard.vue";
import SearchClassesInput from "@/components/SearchClasses/SearchClassesInput.vue";
import NotFound from "@/components/NotFound.vue";

import { validateClasses } from "@/api/paas";
import latinize from "latinize";

export default {
  name: "HandleEditClasses",
  props: {
    data: Array,
    dataRooms: Array,
    dataRoomTypes: Array,
    info: Object,
    default_preference_value: {
      type: Number,
      default: 1,
    },
    admin: {
        type: Boolean,
        default: false
    },
    defaultPreferenceValue: {
      type: Number,
      default: 1
    }
  },
  components: {
    AssistentCard,
    Loading,
    PaasForms,
    SearchClassesInput,
    NotFound
  },
  data() {
    return {
      rooms: [],
      loading_: false,
      sendDialog: false,
      nav: "main",
      search: "",
      classes: [],
      addDialog: false,
      searchClasses: {
        loading: false,
        selected: [],
        classList: [],
        notFound: false,
        validateSelect: false
      },
      dialog: {
        open: false
      },
      roomTypes: [],
      edit: {
        dialog: false,
        placeholder: {},
        idx: undefined
      },
      headers: {
        main: [
          { text: "Código", align: "start", value: "codigo" },
          { text: "Turma", value: "turma" },
          { text: "Departamento", value: "departamento" },
          { text: "Nome", value: "nome" },
          { text: "Horário", value: "horario" },
          { text: "Alunos", value: "alunos" },
          { text: "Docente", value: "docente" },
          {
            text: "PCD",
            value: "pcd",
            helpText:
              "Há discente com mobilidade redusida ou usuário de cadeira de rodas."
          },
          {
            text: "",
            value: "actions",
            align: "end",
            sortable: false
          }
        ],
        search: [
          { text: "Período", align: "start", value: "periodo" },
          { text: "Código", value: "all" },
          { text: "Turma", value: "turma" },
          { text: "Nome", value: "nome" },
          { text: "Horário", value: "horario" },
          { text: "Alunos", value: "alunos" },
          { text: "Docente", value: "docente" },
          { text: "Departamento", value: "departamento" }
        ]
      }
    };
  },
  mounted() {
    if (this.data) {
      this.classes = JSON.parse(JSON.stringify(this.data));
    }
    if (this.dataRooms) {
      this.rooms = this.dataRooms;
      this.headers.main.splice(7, 0, {
        text: "Preferências",
        value: "preferencias",
        sortable: false
      });
    }
    if (this.dataRoomTypes) {
      this.roomTypes = this.dataRoomTypes;
    }
  },
  methods: {
    openSearch() {
      this.searchClasses.selected = [];
      this.searchClasses.classList = [];
      this.nav = "search";
    },
    handleEdit(selected) {
      this.edit.placeholder = JSON.parse(
        JSON.stringify(this.classes[selected.idx])
      );
      this.edit.idx = selected.idx;
      this.edit.dialog = true;
    },
    saveLocal() {
        if(this.admin) return 
        this.$store.dispatch("setRequestData", {
            hash: this.info.hash,
            classes: this.classes,
            rooms: this.rooms
      });
    },
    editItem(item) {
      this.classes[this.edit.idx] = JSON.parse(JSON.stringify(item));
      this.classes.push({});
      this.classes.pop(); //it updates the data table
      //save classes to store
      this.saveLocal();
    },
    addNewClass(item) {
      this.classes = validateClasses([item], this.classes);
      //save classes to store
      this.saveLocal();
    },
    handleDelete(item) {
      this.classes.splice(item.idx, 1);
      //save classes to store
      this.saveLocal();
    },
    handleStartGetClasses() {
      this.searchClasses.loading = true;
      this.searchClasses.selected = [];
      this.searchClasses.classList = [];
    },
    handleFinishGetClasses(success, response) {
      if (!success) this.searchClasses.notFound = true;
      else {
        this.searchClasses.notFound = false;
        this.searchClasses.classList = response;
      }

      this.searchClasses.loading = false;
    },
    //push selected classes from search
    sendClasses() {
      if (this.searchClasses.selected.length > 0) {
        // creates a array of preferences with value = 0
        let preferences = this.roomTypes.map(e => {
          return { name: e, value: this.default_preference_value };
        });

        //adds the new preference array to the select list
        let select = this.searchClasses.selected.map(e => {
          return { ...e, preferencias: preferences };
        });

        //adds it to the instance input
        let classes = validateClasses(select, this.classes);
        this.classes = classes;
        //save classes to store
        this.saveLocal();
        //close the search classes tab
        this.nav = "main";
        this.searchClasses.validateSelect = false;
      } else {
        //if none selected, display a warning
        this.searchClasses.validateSelect = true;
      }
    },
    handleSaveDialog() {
       if(this.admin) this.send()
       else this.sendDialog = true;
    },
    send() {
        if(this.loading_) return

        this.loading_ = true;
        this.$emit("save", this.classes);
    }
  },
  computed: {
    changed() {
        return JSON.stringify(this.data) != JSON.stringify(this.classes);
    },
    exibClass() {
      return this.searchClasses.classList.map((e, idx) => {
        //allow search without special characters
        let dataLatinaze = latinize(`${e.nome} ${e.docente}`);
        let all = `${e.codigo} ${e.nome} ${e.docente} ${dataLatinaze}`;

        return {
          ...e,
          id: e.codigo + "-" + e.turma,
          idx: idx,
          all: all
        };
      });
    },
    addedClasses() {
      return this.classes.map((e, idx) => {
        return {
          ...e,
          id: e.codigo + "-" + e.turma,
          idx: idx,
          preferencias:
            this.rooms.length > 0
              ? e.preferencias.map(e => e.value).every(e => e == 0)
                ? "Inviável"
                : e.preferencias.map(e => e.value).every(e => e == 1)
                ? "s/ preferências"
                : e.preferencias
                    .sort((a, b) => b.value - a.value)
                    .map(el => el.name)[0]
              : ""
        };
      });
    }
  }
};
</script>
